var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewWbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0809 6.5H13.814C14.1546 6.5 14.4547 6.79519 14.4547 7.15392V8.93725C14.4547 9.29597 14.1546 9.59117 13.814 9.59117H10.0809C9.74024 9.59117 9.44019 9.29597 9.44019 8.93725V7.15392C9.44019 6.79519 9.74024 6.5 10.0809 6.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8442 9.4617L11.8442 12.9236",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.947 11.5594H15.7838C16.406 11.5594 16.9245 12.0839 16.9245 12.7133V13.028",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.948 11.5594H8.11114C7.48895 11.5594 6.97046 12.0839 6.97046 12.7133V13.028",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14068 13.0338H7.90354C8.24416 13.0338 8.54422 13.3289 8.54422 13.6877V15.5759C8.54422 15.9346 8.24416 16.2298 7.90354 16.2298H6.14068C5.80006 16.2298 5.5 15.9346 5.5 15.5759V13.6877C5.5 13.3289 5.80006 13.0338 6.14068 13.0338Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9852 13.0374H12.748C13.0886 13.0374 13.3887 13.3326 13.3887 13.6913V15.5796C13.3887 15.9383 13.0886 16.2335 12.748 16.2335H10.9852C10.6445 16.2335 10.3445 15.9383 10.3445 15.5796V13.6913C10.3445 13.3326 10.6445 13.0374 10.9852 13.0374Z",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0965 13.0338H17.8593C18.2 13.0338 18.5 13.3289 18.5 13.6877V15.5759C18.5 15.9346 18.2 16.2298 17.8593 16.2298H16.0965C15.7559 16.2298 15.4558 15.9346 15.4558 15.5759V13.6877C15.4558 13.3289 15.7559 13.0338 16.0965 13.0338Z",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewWbs);
export default __webpack_public_path__ + "static/media/view_wbs.ca6acc3a.svg";
export { ForwardRef as ReactComponent };